import "./polyfills";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import AppLoader from "./AppLoader";
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<AppLoader />);